import styled, { createGlobalStyle } from 'styled-components';
import { COLORS } from '@Commons';

export const LogoutMenuItemContainer = styled.div`
  cursor: pointer;
`;

export const AccountMenuPopupGlobalStyle = createGlobalStyle`
  .account-menu-popup {
    width: 250px;
    border: 1px solid ${COLORS.borderbottom};
    box-shadow: 3px 3px 0px 0px rgba(0, 0, 0, 0.07);
    transform: translateZ(0);
    z-index: 6;
  }
`;
